import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { addDoc, collection, onSnapshot } from "firebase/firestore";
import getSubscriptionStatus from "../backend/getsub";
import { useNavigate } from "react-router-dom";
import "../css/checkout.css";

export default function Checkout() {
    const nav = useNavigate();
    const [loadingBasic, setLoadingBasic] = useState(false);
    const [loadingPro, setLoadingPro] = useState(false);
useEffect(()=>{
    checkSub();
});
    const checkSub = async() =>{
        const subData = await getSubscriptionStatus();
        if(subData.active == true){
            nav("/dash");
        }
    }
  const createCheckoutSession = async (priceId, setLoader) => {
    try {
      if (!auth.currentUser) {
        alert("Please sign in first");
        return;
      }

      setLoader(true);

      const checkoutSessionRef = await addDoc(
        collection(
          db,
          "users",
          auth.currentUser.uid,
          "checkout_sessions"
        ),
        {
          price: priceId,
          success_url: window.location.origin + "/dash",
          cancel_url: window.location.origin + "/checkout"
        }
      );

      onSnapshot(checkoutSessionRef, (snap) => {
        const data = snap.data();
        if (data?.url) {
          window.location.assign(data.url); // Stripe redirect
        }
        if (data?.error) {
          console.error("Stripe error:", data.error.message);
          alert(data.error.message);
        }
      });

    } catch (e) {
      console.error(e);
      alert("Something went wrong.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="payment-container">
      <h1>Select a Plan</h1>
      <p>Choose a subscription to unlock MenuLinker’s full features.</p>

      <div className="plans-grid">

        {/* BASIC */}
        <div className="plan-card">
          <h2>Basic</h2>
          <p style={{color: "black"}} className="price">$5<span>/mo</span></p>

          <ul>
            <li>✓ Unlimmited Online Menus</li>
            <li>✓ QR Code Generator</li>
            <li>✓ Menu Editor</li>
            <li>✓ 1 Template Style</li>
            <li>✓ Basic Analytics</li>
          </ul>

          <button
            className="subscribe-btn"
            disabled={loadingBasic}
            onClick={() =>
              createCheckoutSession("price_1SVI1iHuyGumH9NagidrkDoP", setLoadingBasic)
            }
          >
            {loadingBasic ? "Loading…" : "Choose Basic"}
          </button>
        </div>

        {/* PRO */}
        <div className="plan-card pro">
          <h2>Pro</h2>
          <p style={{color: "white"}}className="price">$10<span>/mo</span></p>

          <ul>
            <li>✓ Everything in Basic</li>
            <li>✓ 6 Template Styles (more to be added)</li>
            <li>✓ Add item images</li>
            <li>✓ Add header image</li>
            <li>✓ Priority Support</li>
          </ul>

          <button
            className="subscribe-btn pro-btn"
            disabled={loadingPro}
            onClick={() =>
              createCheckoutSession("price_1SVI0DHuyGumH9NacSrnz6Fr", setLoadingPro)
            }
          >
            {loadingPro ? "Loading…" : "Choose Pro"}
          </button>
        </div>
      </div>
    </div>
  );
}
